var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ArrayUtils } from "../../../utilities/arrays";
import { autoinject } from "aurelia-dependency-injection";
var ActivityLoggerComposer = /** @class */ (function () {
    function ActivityLoggerComposer() {
        this.vmWithModelSet = [];
    }
    ActivityLoggerComposer.prototype.register = function (vmWithModel) {
        var index = ArrayUtils.findIndex(this.vmWithModelSet, function (x) { return x == vmWithModel; });
        if (index < 0) {
            this.vmWithModelSet.push(vmWithModel);
        }
    };
    ActivityLoggerComposer.prototype.get = function (icon) {
        return this.vmWithModelSet.filter(function (x) { return x.icon == icon; })[0];
    };
    ActivityLoggerComposer.prototype.unregister = function (vmWithModel) {
        var index = ArrayUtils.findIndex(this.vmWithModelSet, function (x) { return x == vmWithModel; });
        if (index >= 0) {
            this.vmWithModelSet.splice(index, 1);
        }
    };
    ActivityLoggerComposer = __decorate([
        autoinject
    ], ActivityLoggerComposer);
    return ActivityLoggerComposer;
}());
export { ActivityLoggerComposer };
var ViewModelPathWithModel = /** @class */ (function () {
    function ViewModelPathWithModel() {
    }
    return ViewModelPathWithModel;
}());
export { ViewModelPathWithModel };
